import React, { useEffect, useState } from 'react';
import { Card, Rate, Spin } from 'antd';
import PublicWebContentService from '../services/publicWebContentService';
import './Home.css';
import './Testimonials.css';

const AVATAR_TINTS = ['#e9f3ff', '#fff4e2', '#eafaf0', '#f3ecff', '#fdeef0'];
const AVATAR_INK = ['#0363d9', '#b35c00', '#16a34a', '#7c3aed', '#e11d48'];
const initials = (name) =>
  (name || 'A')
    .split(' ')
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

const DEFAULT_REVIEWS = [
  { id: 1, name: 'Sabin Shrestha', city: 'Kathmandu', rating: 5, service: 'Smart TV', text: 'Ekdam ramro service! Mero TV tehi din delivery bhayo ra install pani free. Dhanyabaad Current Care.' },
  { id: 2, name: 'Anjana Gurung', city: 'Pokhara', rating: 5, service: 'Washing Machine', text: 'Washing machine kineko, price sasto ra quality ekdam ramro. Technician pani professional thiyo.' },
  { id: 3, name: 'Bikash Thapa', city: 'Lalitpur', rating: 4, service: 'Fridge Repair', text: 'Fridge bigreko thiyo, same day repair garidiyo. Ekdam bharparne ra bharosa laayak service ho.' },
  { id: 4, name: 'Sunita Tamang', city: 'Bhaktapur', rating: 5, service: 'Online Order', text: 'Online order garna sajilo, delivery pani chhito aayo. Nepal kai lagi best electronics store!' },
  { id: 5, name: 'Rajesh Adhikari', city: 'Chitwan', rating: 5, service: 'AC Installation', text: 'Naya AC install garna technician time mai aayo. Kaam safai ra ekdam professional. Recommend garchhu.' },
  { id: 6, name: 'Manisha Karki', city: 'Biratnagar', rating: 5, service: 'Smartphone', text: 'Phone ko price aru pasal bhanda sasto paye, ani warranty pani full. Customer support ekdam helpful.' },
];

const Testimonials = () => {
  const [loading, setLoading] = useState(true);
  const [headline, setHeadline] = useState('Loved by customers across Nepal');
  const [stats, setStats] = useState([
    { number: '12,000+', label: 'Happy Customers' },
    { number: '98%', label: 'Repeat Business' },
  ]);
  const [reviews, setReviews] = useState(DEFAULT_REVIEWS);

  const sectionToMap = (items) => {
    const map = {};
    (items || []).forEach((item) => {
      map[item.content_key] = item.content_value;
    });
    return map;
  };

  useEffect(() => {
    const loadContent = async () => {
      try {
        const apiBase = process.env.REACT_APP_API_URL || '/api';
        const [pageContent, reviewsRes] = await Promise.all([
          PublicWebContentService.getPageContent('testimonials').catch(() => null),
          fetch(`${apiBase}/testimonials`).then((r) => (r.ok ? r.json() : { data: [] })).catch(() => ({ data: [] })),
        ]);

        if (pageContent) {
          const hero = sectionToMap(pageContent.hero);
          const pageStats = sectionToMap(pageContent.stats);
          if (hero.headline) setHeadline(hero.headline);
          const newStats = [];
          if (pageStats.total_reviews) newStats.push({ number: pageStats.total_reviews, label: 'Happy Customers' });
          if (pageStats.satisfaction_rate) newStats.push({ number: pageStats.satisfaction_rate, label: 'Repeat Business' });
          if (newStats.length >= 1) setStats(newStats);
        }

        const reviewsData = reviewsRes?.data || [];
        if (Array.isArray(reviewsData) && reviewsData.length > 0) {
          setReviews(reviewsData);
        }
      } catch (error) {
        console.error('Failed to load testimonials content:', error);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, []);

  const avgRating = (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '96px 0' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="testimonials-page">
      <header className="page-band">
        <div className="page-band-inner">
          <h1>{headline}</h1>
        </div>
      </header>

      {/* Rating summary strip */}
      <div className="rating-strip">
        <div className="rating-strip-inner">
          <div className="rating-hero">
            <div className="score">
              {avgRating}
              <small>/5</small>
            </div>
            <Rate disabled allowHalf defaultValue={Number(avgRating)} />
            <div className="rating-sub">Based on {reviews.length}+ verified reviews</div>
          </div>
          {stats.map((stat) => (
            <div className="rating-stat" key={stat.label}>
              <b>{stat.number}</b>
              <span>{stat.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Masonry of review cards */}
      <section className="home-section">
        <div className="reviews-masonry">
          {reviews.map((review, index) => (
            <div className="review-item" key={review.id || index}>
              <Card className="testimonial-card">
                <div className="review-head">
                  {review.img ? (
                    <img
                      className="review-avatar"
                      src={review.img}
                      alt={review.name}
                      loading="lazy"
                    />
                  ) : (
                    <span
                      className="review-avatar review-avatar--initials"
                      style={{
                        color: AVATAR_INK[index % AVATAR_INK.length],
                        background: AVATAR_TINTS[index % AVATAR_TINTS.length],
                      }}
                      aria-hidden="true"
                    >
                      {initials(review.name)}
                    </span>
                  )}
                  <div>
                    <div className="review-name">{review.name}</div>
                    {review.city ? <div className="review-city">{review.city}</div> : null}
                  </div>
                </div>
                <Rate disabled defaultValue={review.rating} style={{ marginBottom: 12 }} />
                <p className="review-text">{review.text}</p>
                {review.service ? <span className="review-service">{review.service}</span> : null}
              </Card>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
